import Container = createjs.Container;
import LoadQueue = createjs.LoadQueue;
import Stage = createjs.Stage;
import Bitmap = createjs.Bitmap;
import Tween = createjs.Tween;

import AssetManager from "./AssetManager";
import Utils from "./utils";

export default class Spinner {

    private _loader: LoadQueue;
    private _parent: Container;
    private _container: Container;
    private _stage: Stage;
    private _bitmap: Bitmap;
    private _visible: boolean;

    public static addToManifest(manifest: any[]) {
        manifest.push({src: AssetManager.getLibShared('progress.png'), id: 'spinner'});
    }

    public static initializeLoadingSpinner(
      stage: Stage,
      parent: Container,
      onSpinnerLoaded: (spinner: Spinner) => void,
    ): void {
        const spinnerLoadQueue = new createjs.LoadQueue(false);
        const spinnerManifest = [ ];

        Spinner.addToManifest(spinnerManifest);

        spinnerLoadQueue.on('complete', () => {
            onSpinnerLoaded(new Spinner(stage, spinnerLoadQueue, parent));
        });

        spinnerLoadQueue.loadManifest(spinnerManifest);
    }

    public constructor(stage: Stage, loader: createjs.LoadQueue, parent: Container) {
        this._loader = loader;
        this._parent = parent || stage;
        this._stage = stage;
        this._visible = false;
    }

    /**
     * Show centered in screen.
     */
    public showCentered() {
        this.showAt(Utils.WIDTH / 2, Utils.HEIGHT / 2);
    }

    /**
     * Show at a certain position.
     * @param {number} x
     * @param {number} y
     */
    public showAt(x: number, y: number) {

        this._show();

        this._container.x = x;
        this._container.y = y;

        this._parent.addChild(this._container);
    }

    /**
     * Hide with a fade-out, if shown.
     */
    public hide() {
        if (!this._visible)
            return;

        this._visible = false;
        Tween.removeTweens(this._container);
        Tween.get(this._container)
            .to({alpha: 0}, 150)
            .call(() => {
                this._remove();
            });
    }

    /**
     * Hide immediately.
     */
    public hideNow() {
        if (!this._visible)
            return;

        this._visible = false;
        this._remove();
    }

    private _show() {
        if (this._visible) return;

        if (this._container) {
            // current container is still fading out;
            // remove tweens to avoid race condition
            Tween.removeTweens(this._container);
        }

        this._visible = true;
        this._container = new Container();
        this._container.alpha = 0;

        this._bitmap = new Bitmap(this._loader.getResult('spinner'));
        this._bitmap.regX = this._bitmap.image.width/2;
        this._bitmap.regY = this._bitmap.image.height/2;
        this._container.addChild(this._bitmap);

        // fade in
        Tween.get(this._container)
            .to({alpha: 1}, 300);

        // rotation
        this._startRotate();
    }

    private _remove() {
        this._parent.removeChild(this._container);
        this._container = null;
        this._bitmap = null;
    }

    private _startRotate() {
        this._bitmap.rotation = -90;
        Tween.get(this._bitmap)
            .to({rotation: 270}, 1000)
            .call(() => {
                if (this._visible)
                    this._startRotate();
            });
    }

}



// WEBPACK FOOTER //
// ../lib/src/Spinner.ts